__webpack_require__.p = "/cpr-tasks/referrals-hub/";